import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "fixed inset-0 overflow-y-auto" };
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4 text-center" };
const _hoisted_3 = {
    key: 2,
    class: "graphic",
    style: { "padding": "0 !important" }
};
const _hoisted_4 = {
    align: "center",
    width: "100%",
    cellspacing: "0",
    cellpadding: "0",
    style: { "page-break-after": "always" }
};
const _hoisted_5 = {
    colspan: "36",
    class: "py-2"
};
const _hoisted_6 = { valign: "bottom" };
const _hoisted_7 = {
    border: "0",
    cellspacing: "0",
    cellpadding: "0"
};
const _hoisted_8 = {
    align: "center",
    style: { "text-align": "center" }
};
const _hoisted_9 = {
    valign: "bottom",
    align: "center"
};
const _hoisted_10 = {
    align: "center",
    style: { "text-align": "center" }
};
const _hoisted_11 = { class: "mt-7" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_font = _resolveComponent("font");
    return (_openBlock(), _createBlock($setup["TransitionRoot"], {
        appear: "",
        show: $props.isOpen,
        as: "template"
    }, {
        default: _withCtx(() => [
            _createVNode($setup["Dialog"], {
                as: "div",
                class: "relative z-[999]",
                onClose: _cache[1] || (_cache[1] = ($event) => ($setup.emit('close')))
            }, {
                default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("div", {
                        class: "fixed inset-0 bg-black/30",
                        "aria-hidden": "true"
                    }, null, -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode($setup["DialogPanel"], { class: "transform overflow-auto rounded bg-white p-6 text-left align-middle shadow-xl transition-all max-w-full w-[1200px]" }, {
                                default: _withCtx(() => [
                                    _createVNode($setup["DialogTitle"], {
                                        as: "h3",
                                        class: "h2 mb-[30px] lg:mb-[40px]"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($props.query.prefix) + " " + _toDisplayString($props.query.alloy) + " " + _toDisplayString($props.query.to), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    ($setup.isLoading)
                                        ? (_openBlock(), _createBlock($setup["LoadingSpinner"], { key: 0 }))
                                        : ($setup.error)
                                            ? (_openBlock(), _createBlock($setup["LoadingError"], {
                                                key: 1,
                                                title: $setup.error
                                            }, null, 8 /* PROPS */, ["title"]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alloyData, (surcharges) => {
                                                    return (_openBlock(), _createElementBlock("table", _hoisted_4, [
                                                        _createElementVNode("tbody", null, [
                                                            _createElementVNode("tr", null, [
                                                                _createElementVNode("th", _hoisted_5, _toDisplayString(surcharges.head), 1 /* TEXT */)
                                                            ]),
                                                            _createElementVNode("tr", null, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surcharges.body.rows, (row) => {
                                                                    return (_openBlock(), _createElementBlock("td", _hoisted_6, [
                                                                        _createElementVNode("table", _hoisted_7, [
                                                                            _createElementVNode("tbody", null, [
                                                                                _createElementVNode("tr", null, [
                                                                                    _createElementVNode("td", _hoisted_8, [
                                                                                        _createVNode(_component_font, {
                                                                                            size: "-4",
                                                                                            class: "whitespace-pre-line"
                                                                                        }, {
                                                                                            default: _withCtx(() => [
                                                                                                _createTextVNode(_toDisplayString(row[0]), 1 /* TEXT */)
                                                                                            ]),
                                                                                            _: 2 /* DYNAMIC */
                                                                                        }, 1024 /* DYNAMIC_SLOTS */)
                                                                                    ])
                                                                                ]),
                                                                                _createElementVNode("tr", null, [
                                                                                    _createElementVNode("td", _hoisted_9, [
                                                                                        _createElementVNode("span", {
                                                                                            style: _normalizeStyle({
                                                                                                backgroundColor: row[1].backgroundColor,
                                                                                                width: '15px',
                                                                                                height: row[1].height,
                                                                                                display: 'block',
                                                                                            })
                                                                                        }, null, 4 /* STYLE */)
                                                                                    ])
                                                                                ]),
                                                                                _createElementVNode("tr", null, [
                                                                                    _createElementVNode("td", _hoisted_10, [
                                                                                        _createVNode(_component_font, {
                                                                                            size: "-5",
                                                                                            class: "whitespace-pre-line"
                                                                                        }, {
                                                                                            default: _withCtx(() => [
                                                                                                _createTextVNode(_toDisplayString(row[2]), 1 /* TEXT */)
                                                                                            ]),
                                                                                            _: 2 /* DYNAMIC */
                                                                                        }, 1024 /* DYNAMIC_SLOTS */)
                                                                                    ])
                                                                                ])
                                                                            ])
                                                                        ])
                                                                    ]));
                                                                }), 256 /* UNKEYED_FRAGMENT */))
                                                            ])
                                                        ])
                                                    ]));
                                                }), 256 /* UNKEYED_FRAGMENT */))
                                            ])),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("button", {
                                            class: "button",
                                            onClick: _cache[0] || (_cache[0] = ($event) => ($setup.emit('close')))
                                        }, "Close")
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]));
}
